/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { updateUserInfoSchema } from "../updateUserInfoSchema.ts";
import { userSchema } from "../userSchema.ts";
import { z } from "zod";

export const updateCurrentUserHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application")
      })

/**
 * @description Informations utilisateur mises à jour avec succès.
 */
export const updateCurrentUser200Schema = z.lazy(() => userSchema)

/**
 * @description Réponse d\'erreur standard
 */
export const updateCurrentUser404Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const updateCurrentUserMutationRequestSchema = z.lazy(() => updateUserInfoSchema)

export const updateCurrentUserMutationResponseSchema = z.lazy(() => updateCurrentUser200Schema)